export default __webpack_public_path__ + "static/media/logo.e6d52de9.png";